"use strict";

const HTMLElementImpl = require("./HTMLElement-impl").implementation;

class HTMLOListElementImpl extends HTMLElementImpl {
  get start() {
    const value = parseInt(this.getAttribute("start"));

    if (!isNaN(value)) {
      return value;
    }

    return 1;
  }
  set start(value) {
    this.setAttribute("start", value);
  }
}

module.exports = {
  implementation: HTMLOListElementImpl
};



//////////////////
// WEBPACK FOOTER
// ./node_modules/_jsdom@13.2.0@jsdom/lib/jsdom/living/nodes/HTMLOListElement-impl.js
// module id = 0OZc
// module chunks = 0